import { ApplicationConfig, importProvidersFrom, PLATFORM_ID, provideZoneChangeDetection } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { PreloadAllModules, provideRouter, withPreloading, withViewTransitions } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ReactiveFormsModule } from '@angular/forms';

import { routes } from './app.routes';
import { UtilClass } from './utils/utilClass';
import { DefaultMatCalendarRangeStrategy, MatRangeDateSelectionModel } from '@angular/material/datepicker';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt'; // Import the service
import 'hammerjs';
import { HammerModule } from '@angular/platform-browser';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DEFAULT_CURRENCY_CODE } from '@angular/core';

import { provideOAuthClient } from 'angular-oauth2-oidc';
import { AuthInterceptor } from './auth.interceptor';

const getStartupLocale = (platformId: object) => {
  if (isPlatformBrowser(platformId)) {
    const stored = localStorage.getItem('locale');
    if (stored) return stored; // e.g. 'de-AT' or 'da-DK'
    return navigator.language; // fallback
  }
  return 'de-AT';
};
const locale = getStartupLocale(typeof window !== 'undefined' ? PLATFORM_ID : PLATFORM_ID);

export const appConfig: ApplicationConfig = {
  providers: [
    ReactiveFormsModule,
    UtilClass,
    DefaultMatCalendarRangeStrategy,
    MatRangeDateSelectionModel,
    JwtHelperService,
    { provide: JWT_OPTIONS,           useValue: { tokenGetter: () => localStorage.getItem(`id_token`) } },
    { provide: DEFAULT_CURRENCY_CODE, useValue: locale.startsWith('en') ? 'EUR' : 'EUR' },
    { provide: 'LOCALE_ID',           useValue: locale },
    { provide: MAT_DATE_LOCALE,       useValue: locale },
    { provide: PLATFORM_ID,           useValue: typeof window !== 'undefined' ? 'browser' : 'server' },
    { provide: HTTP_INTERCEPTORS,     useClass: AuthInterceptor, multi: true },
    importProvidersFrom(HammerModule),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules), withViewTransitions()),
    provideAnimations(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideOAuthClient(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix:".json"}),
    }),
  ],
};
